/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBrightspotViewProps } from './mfrm-brightspot';

export default (props: IBrightspotViewProps) => {
    const {
        data: { brightSpotContent }
    } = props;

    // Remove Doctype
    let brightspotHTML = brightSpotContent.result?.replace(/<!DOCTYPE(.*?)>/i, '');

    // Remove HTML tag
    brightspotHTML = brightspotHTML?.replace(/<html(.*?)>|<\/html>/gi, '');

    // Remove <head> open/close tags
    brightspotHTML = brightspotHTML?.replace(/<head(.*?)>|<\/head>/gi, '');

    // If the content contains a <body>, replace with a div
    brightspotHTML = brightspotHTML?.replace(/<body (.*?)>/i, '<div $1>');

    // If the content contains a </body>, replace with </div>
    brightspotHTML = brightspotHTML?.replace(/<\/body>/i, '<\/div>');

    return (
        <div className='brightspot-container brightspot-container__delivery-service'>
            <div id={"syndicate"} dangerouslySetInnerHTML={{ __html: brightspotHTML }} />
        </div>
    );
};
